import React from "react";
import { Route } from "react-router-dom";
import { menuConfig } from "../configs/MenuConfig";
import * as DriverPages from "../pages/driver";
import DriverPanel from "../pages/driver/DriverPanel";
import PanelLayout from"../layouts/PanelLayout"
import ProtectedRoute from "../components/ProtectedRoute";
import DriverProfileEdit from "../pages/driver/DriverProfileEdit";
import CarrierProfileEdit from "../pages/carrier/CarrierProfileEdit";


function renderRoutes(items = []) {
  return items.map(({ link, component, submenu }) => {
    const Page = component ? DriverPages[component] : undefined;

    return (
      <Route key={link} path={link} element={Page ? <Page /> : undefined}>
        {submenu && renderRoutes(submenu)}
      </Route>
    );
  });
}

export default function DriverRoutes() {
  const routes = menuConfig.driver.items;

  return (
    <Route path="/driver-panel" element={<ProtectedRoute allowedRoles={["driver","admin"]}><PanelLayout user ='driver'/></ProtectedRoute>}>
      <Route path="driver-profile-edit" element={<DriverProfileEdit />} />
     <Route index element={<DriverPanel />} />
     {renderRoutes(routes)}
    </Route>
);
}